import Nullstack from 'nullstack';
export default function IconLogicBuffer({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-logic-buffer",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M22 12h-5"
  }), "   ", Nullstack.element("path", {
    d: "M2 9h5"
  }), "   ", Nullstack.element("path", {
    d: "M2 15h5"
  }), "   ", Nullstack.element("path", {
    d: "M7 5l10 7l-10 7z"
  }), " ");
}